module.exports = __webpack_public_path__ + "static/media/bt.c8fb8a8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bt.png
// module id = 1807
// module chunks = 0